import React, { useEffect, useState } from 'react';
import * as R from 'ramda';

import { UsersTableHeader } from './header';
import { UsersTableRow } from './row';
import { UsersTableNav } from './nav';

import Emptylustration from './../../../../../assets/images/svg/057-contract-1.svg';
import * as Loadings from '../../../../../constants/loadings/backoffice/partners';
import { LoadingState } from '../../../../../_common/loadingState';


export const UsersTable = ({ users, setSelectedUser, etablissements, partnerState, partner, pageSearch, setPageSearch, routerQuery }) => {

    const [filters, setFilters] = useState({
        order: {
            column: "name",
            asc: true
        },
        search: "",
        status: "all",
        role: "all",
    });

    const [displayableElements, setDisplayableElements] = useState(undefined);

    useEffect(() => {
        let temp = users;
        // if (!R.isEmpty(filters.search)) {
        //     temp = temp.filter(d => d.firstName.search(filters.search) > -1 || d.lastName.search(filters.search) > -1 || d.phoneNumber.search(filters.search) > -1);
        // }
        // if (filters.status === "active") {
        //     temp = temp.filter(d => d.isEnabled);
        // }
        // if (filters.status === "inactive") {
        //     temp = temp.filter(d => !d.isEnabled);
        // }
        // if (filters.role === "administrator") {
        //     temp = temp.filter(d => R.isNil(d.etablissementId));
        // }
        // if (filters.role === "etablissement") {
        //     temp = temp.filter(d => !R.isNil(d.etablissementId));
        // }


        // setDisplayableElements(filters.order.asc ? R.sort(R.ascend(R.prop(filters.order.column)), temp) : R.sort(R.descend(R.prop(filters.order.column)), temp));
        setDisplayableElements(temp);

    }, [filters, users]);


    return (
        <div className="container-fluid h-inherit flex-column">
            <UsersTableNav filters={filters} setFilters={setFilters} pageSearch={pageSearch} setPageSearch={setPageSearch} routerQuery={routerQuery} partnerState={partnerState} />
            {
                partnerState.isLoading.includes(Loadings.FETCHING_USERS) ?
                    <LoadingState />
                    :
                    <section className="block">
                        <h1 className="sr-only visually-hidden">Utilisateurs</h1>

                        {R.isNil(displayableElements) || displayableElements <= 0 ?
                            <section className="block fs-3 text-center m-auto py-5">
                                <img className="img-fluid img-contain container-paper mx-auto mb-4" src={Emptylustration} alt="Assist@" />
                                <div className="block text-center container-thin mx-auto">
                                    <h1 className="font-weight-bolder ls-n2 lh-1">Il n'y a pas d'utilisateurs.</h1>
                                    <p className="o-80 mb-0">Veuillez ajouter un nouvel utilisateur.</p>
                                </div>
                            </section>
                            :
                            <React.Fragment>
                                <UsersTableHeader filters={filters} setFilters={setFilters} routerQuery={routerQuery} partnerState={partnerState} />
                                {displayableElements.map((user) => {
                                    return (
                                        <UsersTableRow key={user.id} user={user} setSelectedUser={setSelectedUser} etablissements={etablissements} />
                                    );
                                })
                                }

                            </React.Fragment>
                        }

                    </section>
            }
        </div>
    );

};